<div class="trip-advisor-view" [@opacityFade]>
  <mat-icon svgIcon="search-result-dialog-common.trip-advisor-svg" (click)="navigateToExternal(data.webUrl || '')"></mat-icon>

  <ng-container *ngIf="data?.attractionTypes?.length">
    <div class="trip-advisor-view--categories" (click)="navigateToExternal(data.webUrl || '')">
      <ng-container *ngFor="let item of data.attractionTypes;let isFirst = first">
        <p *ngIf="!isFirst">•</p>
        <p>{{ item }}</p>
      </ng-container>
    </div>
  </ng-container>

  <div class="trip-advisor-view--review" (click)="navigateToExternal(data.webUrl || '')">
    <img
      [defaultImage]="''"
      [lazyLoad]="data?.ratingImgUrl || ''"
      [errorImage]="''"
      alt="Trip Advisor rating image">
    <p *ngIf="(data?.numReviews || 0) > 0">{{ 'search-result.based-on' | translate }} <span class="ht-digit">{{ data.numReviews }} {{ 'search-result.reviews' | translate }}</span></p>
  </div>
  <p class="ht-digit" (click)="navigateToExternal(data.webUrl || '')" *ngIf="data.ranking">{{ data.ranking }}</p>
  <p class="ht-digit" (click)="navigateToExternal(data.webUrl || '')" *ngIf="data.subRanking">{{ data.subRanking }}</p>
</div>